import React from 'react'
import styled from 'styled-components'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

import Header from 'components/Header'
import Post from 'components/Post'
import ContactMe from 'components/ContactMe'
import Story from 'components/Story'
import AboutMe from 'components/AboutMe'
import Home from 'components/Home'

const Wrapper= styled.div`
display: flex;
flex-direction: column;
align-content: center;
`

export const App = () => {
  return (
    <BrowserRouter>
    <Wrapper>
      <Header />

     <Routes>

     <Route path="/" element={<Home />} />

      <Route path="post" element={<Post />} />
      
       <Route path="contactme" element={<ContactMe />} />

       <Route path="story" element={<Story />} />

       <Route path="about" element={<AboutMe />} />
     </Routes>
      
    
      </Wrapper>
      </BrowserRouter>
  )
}
